var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.860352H513V342.827H0V0.860352Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 67.891V0.860352H412.504L0 275.796V342.827H100.496L513 67.891Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 0.860352V41.0387L60.3176 342.827H0V302.649L452.682 0.860352H513Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7828 32.1211L110.115 82.6195H163.318L120.335 113.88L136.767 164.479L93.7828 133.218L50.6988 164.479L67.1309 113.88L24.1471 82.6195H77.3508L93.7828 32.1211Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.860352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCd);
export default __webpack_public_path__ + "static/media/CD.0f67f445f73195008b834c2d2f908161.svg";
export { ForwardRef as ReactComponent };